import Moment from 'moment-timezone'

export type AccountSettings = {
  deliveryAndServiceFeeCapHoliday: number | undefined
  deliveryAndServiceFeeCapWeekday: number | undefined
  deliveryAndServiceFeeCapWeekend: number | undefined
  deliveryAndServiceFeePercentHoliday: number | undefined
  deliveryAndServiceFeePercentWeekday: number | undefined
  deliveryAndServiceFeePercentWeekend: number | undefined
  gratuity: number | undefined
  gratuityType: string | undefined
}

export type CobrandingSettings = {
  id: string
  accountId: string
  active: boolean
  navBarId: string
  createdAt: Moment.Moment
  updatedAt: Moment.Moment
  _destroy?: boolean
}

export type ApiCobrandingSettings = {
  id: string
  account_id: string
  active: boolean
  nav_bar_id: string
  created_at: string
  updated_at: string
  _destroy?: boolean
}

export const apiCobrandingSettingsToCobrandingSettings = (
  apiSettings: ApiCobrandingSettings,
): CobrandingSettings => {
  const settings: CobrandingSettings = {
    id: apiSettings.id,
    accountId: apiSettings.account_id,
    active: apiSettings.active,
    navBarId: apiSettings.nav_bar_id,
    createdAt: Moment(apiSettings.created_at),
    updatedAt: Moment(apiSettings.updated_at),
  }

  return settings
}
